import styles from './index.module.scss';
import QrBarcodeScanner from 'components/atoms/QrBarcodeScanner';

type CollectRouteBookingQRScannerProps = {
  successCallback: (qrCodeId: string) => void;
  paused?: boolean;
};

const CollectRouteBookingQRScanner = ({
  successCallback,
  paused,
}: CollectRouteBookingQRScannerProps) => {
  const qrCodeSuccessCallback = (decodedText: string) => {
    if (decodedText) {
      successCallback(encodeURIComponent(decodedText));
    }
  };

  return (
    <div className={styles.recycleQRScanning}>
      <div className={styles.recycleQRScanningBody}>
        <div className={styles.scanQRCode}>
          <QrBarcodeScanner
            onScanSuccess={qrCodeSuccessCallback}
            paused={paused}
            classNames={{
              container: styles.empty,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CollectRouteBookingQRScanner;
